import { createContext, useContext } from 'react';

const ProcurementContext = createContext();

export const useProcurement = () => {
    const context = useContext(ProcurementContext);

    if (!context) {
        throw new Error('useProcurementContext must be used within a ProcurementContext');
    }

    return context;
};

export default ProcurementContext;
